/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_No_SignalInputs */

const en_directory_launch_no_signal = /** @type {(inputs: Directory_Launch_No_SignalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough signal yet`)
};

const zh_directory_launch_no_signal = /** @type {(inputs: Directory_Launch_No_SignalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂时没有足够信号`)
};

/**
* | output |
* | --- |
* | "Not enough signal yet" |
*
* @param {Directory_Launch_No_SignalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_no_signal = /** @type {((inputs?: Directory_Launch_No_SignalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_No_SignalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_no_signal(inputs)
	return zh_directory_launch_no_signal(inputs)
});
export { directory_launch_no_signal as "directory.launch.no_signal" }